<template>
  <div style="padding: 10px 10px 10px 0">
    <el-dialog title="详情" :visible.sync="show" width="40%">
      <el-form :model="obj" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="visitor" label="访客姓名">
              <el-input v-model="obj.visitor" disabled=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phone" label="访客手机号">
              <el-input v-model="obj.phone" disabled=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="idCard" label="访客身份证号">
              <el-input v-model="obj.idCard" disabled=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="intervieweeName" label="被访人姓名">
              <el-input v-model="obj.intervieweeName" disabled=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="roomNumber" label="被访问人房间号">
              <el-input v-model="obj.roomNumber" disabled=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="consumption" label="访问时间">
              <el-input v-model="obj.visitingTime" disabled=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="departureTime" label="访问结束时间">
              <el-input v-model="obj.departureTime" disabled=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="createTime" label="提交时间">
              <el-input v-model="obj.createTime" disabled=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="reason" label="来访原因">
              <el-input
                type="textarea"
                rows="10"
                v-model="obj.reason"
                disabled=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item prop="createTime" label="苏康码">
							<img style="width: 100px;" :src="obj.showHealthPath" alt="">
						</el-form-item>
						<el-form-item prop="createTime" label="行程码">
							<img style="width: 100px;" :src="obj.showTripPath" alt="">
						</el-form-item> -->
            <!-- 	<div>
							苏康码
							行程码<img  style="width: 100px;" :src="obj.showTripPath" alt="">
						</div> -->
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <div class="flex sb">
        <div>
          <el-form-item label="访客姓名">
            <el-input v-model="form.visitor" placeholder="访客姓名"></el-input>
          </el-form-item>
          <el-form-item label="访客手机号">
            <el-input v-model="form.phone" placeholder="访客手机号"></el-input>
          </el-form-item>
          <el-form-item label="访问时间">
            <el-date-picker
              v-model="form.startTime"
              type="date"
              placeholder="访问开始时间"
            >
            </el-date-picker>
            <span>-</span>
            <el-date-picker v-model="form.endTime" type="date" placeholder="访问结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="访问状态">
            <el-select v-model="form.result" placeholder="状态">
              <el-option label="已来访" value="已来访"></el-option>
              <el-option label="未来访" value="未来访"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="getAll">查询</el-button>
            <el-button type="primary" @click="cz">重置</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-table :data="data" style="width: 100%" border>
      <el-table-column prop="visitor" label="访客姓名"></el-table-column>
      <el-table-column prop="phone" label="访客手机号"></el-table-column>
      <el-table-column prop="img" label="访客照片">
        <template slot-scope="{ row }">
          <img :src="row.img || require('../../assets/icon/user1.png')" style="width: 40px; height: 40px" ></img>
        </template>
      </el-table-column>
      <el-table-column prop="intervieweeName" label="被访问人姓名"></el-table-column>
      <el-table-column prop="visitingTime" label="访问时间">
        <template slot-scope="{ row }">{{ setTime(row.visitingTime) }}</template>
      </el-table-column>
      <el-table-column prop="roomNumber" label="被访问人房间号"></el-table-column>
      <!-- 	<el-table-column prop="phone" label="提交时间">
				<template slot-scope="{row}">{{row.phone?row.phone:"无"}}</template>
			</el-table-column> -->
      <el-table-column prop="createTime" label="提交时间">
        <template slot-scope="{ row }">{{ setTime(row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="result" label="访问状态"></el-table-column>
      <el-table-column prop="date" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="lookRow(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 30, 50]"
      :page-size="form.pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      count: 0,
      users: [], //申请人
      show: false,
      form: {
        visitor: null,
        phone: null,
        startTime: null,
        endTime: null,
        result: null,
        currentPage: 1,
        pageSize: 10,
      },
      addForm: {},
      data: [],
      obj: {
        fileRes: "",
      }, //详情数据
    };
  },
  methods: {
    cz() {
      this.form = {
        intervieweeName: null,
        visitingTime: null,
        departureTime: null,
        result: null,
        currentPage: 1,
        pageSize: 10,
        currentPage: 1,
        pageSize: 10,
      };
      this.getAll();
    },

    lookRow(obj) {
      this.obj = {
        ...obj,
      };
      this.show = true;
    },
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAll();
    },

    getAll() {
      //获取表格数据

      this.$http
        .post("/api/bdVisitApply/queryWebVisitApply", {
          ...this.form,
        })
        .then((res) => {
          console.log(res);
          if (res.data.data != null) {
            this.count = res.data.data.totalNum;
            this.data = res.data.data.items;
          } else {
            this.count = 0;
            this.data = null;
          }
        });
    },
  },
  created() {
    this.getAll();
  },
};
</script>

<style scoped="scoped">
.box {
  font-size: 16px;
  width: 70%;
}

.box > div {
  margin-bottom: 10px;
}
</style>
